<div class="content-container">
  <div class="video-container fullScreen">
    <div class="videobg">
      <div class="videobg-width">
        <div class="videobg-aspect">
          <div id="video-with-controls" class="videobg-make-height">
            <div class="video-wrapper">
              <video #videoEl playsinline crossorigin="anonymous" [poster]="posterUrl"></video>
            </div>
            <div class="play-next-wrapper grad">
              <div class="play-next">
                <svg data-testid="intro-video-play" (click)="onPlay()" xmlns="http://www.w3.org/2000/svg" width="96" height="96" style="background:transparent" viewBox="0 0 96 96">
                  <g fill="none" fill-rule="evenodd">
                    <path d="M0 0h96v96H0z"/>
                    <path fill="#FFF" d="M32 20v56l44-28z"/>
                  </g>
                </svg>
              </div>
            </div>
            @if (loadedPlay) {
              <div class="absolute-divs controls-container">
                <div class="controls-group">
                  @if (!underPlay) {
                    <button aria-label="Play" type="button" class="btn btn-link svg-bg play" (click)="onPlay()"></button>
                  }
                  @if (underPlay) {
                    <button aria-label="Pause" type="button" class="btn btn-link svg-bg pause" (click)="onPause()"></button>
                  }
                  @if (!OnCaption) {
                    <button title="Turn subtitles on" aria-label="Turn subtitles on" type="button" class="btn btn-link svg-bg offsubtitles" (click)="OnSubtitles()"></button>
                  }
                  @if (OnCaption) {
                    <button title="Turn subtitles off" aria-label="Turn subtitles off" type="button" class="btn btn-link svg-bg onsubtitles" (click)="OffSubtitles()"></button>
                  }
                  @if (current > 5) {
                    <button aria-label="Rewind" type="button" class="btn btn-link svg-bg backward" (click)="onBackward()"></button>
                  }
                  @if (isReplay) {
                    <button aria-label="Fast forward" type="button" class="btn btn-link svg-bg forward" (click)="onForward()"></button>
                  }
                </div>
                <div class="time-group">
                  <div class="max">{{ duration | secondsToTime }}</div>
                  <div class="separator">|</div>
                  <div class="current">{{ current | secondsToTime }}</div>
                </div>
                <div class="clearfix"></div>
                <div class="progress-group">
                  <div class="played" (click)="onClickProgress($event)" [ngStyle]="{width: progressValue + '%'}"></div>
                  <div class="current" [ngStyle]="{left: progressValue + '%'}"></div>
                  <div class="unplayed" [ngStyle]="{width: (100 - progressValue) + '%'}"></div>
                </div>
              </div>
            }
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="clearfix"></div>
</div>
